export default __webpack_public_path__ + "static/media/IconLocationPin.91ebcb25.svg";